import { useSetCalendlyAppointmentNoShowMutation } from '../../shared';
import * as React from 'react';
import { StyledToggle } from '../styled-toggle';
import { useTagMissAppConfirm } from './use-tag-miss-app-confirm';

interface ShowedUpToggleProps {
  noShow?: boolean | null,
  appUrl: string,
  clientId: string,
  onChange?: () => void
}

export const ShowedUpToggle = ({noShow, appUrl, onChange, clientId}: ShowedUpToggleProps) => {
  const [setNoShow, {loading}] = useSetCalendlyAppointmentNoShowMutation({
    refetchQueries: ['clientCalendlyAppointments'],
    awaitRefetchQueries: true
  })
  const showTagMissAppConfirmationModal = useTagMissAppConfirm(clientId)

  const handleClick = async (value: boolean) => {
    if (!value) {
      const res = await showTagMissAppConfirmationModal();
      if (!res) return;
    }

    if (onChange) {
      onChange();
    }
    setNoShow({variables: {id: appUrl, noShow: !value}})
  }

  return <StyledToggle onChange={(e, v) => handleClick(v)} value={noShow === undefined || noShow === null ? null : !noShow} loading={loading} />
}
